import { ApiError } from './ApiError';

export class UnauthorizedError extends ApiError {
  constructor(message: string, errors: unknown[] = []) {
    super(401, message, errors);
    this.name = 'UnauthorizedError';
  }
}
